export const SET_PRO_ACCOUNT = 'SET_PRO_ACCOUNT';
export const CLEAR_PRO_ACCOUNT = 'CLEAR_PRO_ACCOUNT';
